import { HOW_IT_WORKS_STEPS } from '../constants';
import * as styled from '../styles/how-it-works';
import { SectionHeading } from './section-heading';

export const HowItWorks = () => (
  <styled.Wrap>
    <SectionHeading kicker="How it works" title="Four steps, then it repeats." />
    <styled.StepGrid>
      {HOW_IT_WORKS_STEPS.map((step) => (
        <styled.StepCard key={step.number}>
          <styled.StepNumber $highlight={step.accent === 'highlight'}>{step.number}</styled.StepNumber>
          <styled.StepTitle>{step.title}</styled.StepTitle>
          <styled.StepDescription>{step.description}</styled.StepDescription>
        </styled.StepCard>
      ))}
    </styled.StepGrid>
  </styled.Wrap>
);
